export default __webpack_public_path__ + "static/media/block.8f99db12.svg";